import {
    CONFIRM,
    EMAIL_REQUIRED,
    INVALID_EMAIL,
    NAME_CHARACTER_ERROR,
    NAME_MAX_LENGTH,
    PASSWORD_REQUIRED,
    PLEASE_FILL_NAME
} from '../../constants/onboarding';

/**
 * This function validate the email.
 */
export const emailValidation = (value: string) => {
    if (value === '') return EMAIL_REQUIRED;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return INVALID_EMAIL;
    }
    return '';
};

/**
 * This function validate the password returns it as required field
 */
export const passwordValidation =
    ({ isConfirmPassword = false }) =>
    (value: string) => {
        const prefix = isConfirmPassword ? `${CONFIRM} ` : '';
        if (value === '') return prefix + PASSWORD_REQUIRED;
        if (isConfirmPassword) return '';
        return '';
    };

/**
 * This function validate the name and return an error message if any.
 * Name should have atleast one alphabet.
 * Name should not exceed 70 characters.
 */
export const userNameValidator = (value: string) => {
    if (value.length === 0) return PLEASE_FILL_NAME;
    if (value.search(/[A-Za-z]/) < 0) return NAME_CHARACTER_ERROR;
    if (value.length > 70) return NAME_MAX_LENGTH;
    return '';
};
